import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ButtonPrimary from '../../../../components/button/ButtonPrimary';

const AppNotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };
    
    return (
        <div className='flex flex-col min-h-screen items-center justify-center bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-secondary via-accent to-secondary'>
            <div className='flex flex-col p-5 items-center justify-center space-y-5'>
                <div className='flex flex-col items-center justify-center space-y-2'> 
                    <h1 className='text-xl md:text-2xl font-semibold'>404 - {t('notFound.title')}</h1>
                    <p className='text-center'>{t('notFound.description')}</p>
                </div>
                <ButtonPrimary className='md:text-sm' onClick={handleGoToDashboard}>{t('notFound.goToDashboard')}</ButtonPrimary>
            </div>
        </div>
    );
};

export default AppNotFound;
